import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

// Dummy utility to simulate "time ago"
const time_ago = (date) => {
  const diff = Math.floor((new Date() - new Date(date)) / (1000 * 60 * 60 * 24));
  return diff === 0 ? 'Today' : `${diff} day${diff > 1 ? 's' : ''} ago`;
};

const NewLiveLocationDetails = ({ userData }) => {
  const selectedUser = {
    lastLocation: {
      city: userData?.city,
      distance: 0,
    },
    createdAt: userData?.createdAt,
    isOnLine: userData?.isOnLine,
    lastActive: (userData?.lastLogin ?? userData?.lastActive),
    isProfileVerified: userData?.isProfileVerified,
    isIdVerified: userData?.isIdVerified,
    distance: userData?.distance,
    accountSetting: {
      privacySettings: {
        status: userData?.accountSetting?.privacySettings?.status,
      },
    },
  };

  const user = {
    preferredMeasurement: false, // false = km, true = miles
  };

  // console.log("userData", userData)
  // ✅ Logic
  const distance =
    selectedUser?.distance === 0 ? 1 : selectedUser?.distance;
  const measurementUnit = user?.preferredMeasurement ? 'miles' : 'km';

  const showStatus =
    selectedUser?.accountSetting?.privacySettings?.status === undefined ||
    selectedUser?.accountSetting?.privacySettings?.status === true;

  return (
    <Box className="liveLctDetals" sx={{ py: 1 }}>
      <Stack component="ul" spacing={1} sx={{ listStyle: 'none', m: 0, p: 0 }}>

          <Typography component="li" sx={{fontSize:'14px'}}>
         Location {' '}
          <Typography component="span" color="text.secondary" sx={{fontSize:'14px'}}>
           {selectedUser.lastLocation?.city}{' '} 
          </Typography>
        </Typography>
        {distance && <Typography component="li" sx={{fontSize:'14px'}}>
          Distance {' '}
          <Typography component="span" color="text.secondary" sx={{ fontSize: '14px' }}>
            {distance} {measurementUnit}
          </Typography>
        </Typography>}

        <Typography component="li" sx={{fontSize:'14px'}}>
          Member Since{' '}
          <Typography component="span" color="text.secondary" sx={{fontSize:'14px'}}>
            {selectedUser.createdAt ? time_ago(selectedUser.createdAt) : 'NA'}
          </Typography>
        </Typography>

        {showStatus && (
          <Typography component="li" sx={{fontSize:'14px'}}>
            Status{' '}
            <Typography sx={{fontSize:'14px'}} component="span" color={selectedUser?.isOnLine ? 'green' : 'text.secondary'}>
              {selectedUser?.isOnLine ? 'online' : 'offline'}
            </Typography>
          </Typography>
        )}

        {showStatus && !selectedUser?.isOnLine && (
          <Typography component="li" sx={{fontSize:'14px'}}>
            Last Active{' '}
            <Typography component="span" color="text.secondary" sx={{fontSize:'14px'}}>
              {time_ago(selectedUser?.lastActive)}
            </Typography>
          </Typography>
        )}

        <Typography component="li" sx={{fontSize:'14px'}}>
          Verification{' '}
          <Typography sx={{fontSize:'14px'}}
            component="span"
            color={
              selectedUser?.isProfileVerified || selectedUser?.isIdVerified
                ? 'green'
                : 'text.secondary'
            }
          >
            {selectedUser?.isProfileVerified || selectedUser?.isIdVerified
              ? 'Verified'
              : 'Not Verified'}
          </Typography>
        </Typography>
      </Stack>
    </Box>
  );
};

export default NewLiveLocationDetails;
